module.exports = __webpack_public_path__ + "70b7f2d817237e71cc28c7224503fb8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chloe/stamps/11_PROP_VET_11-1.png
// module id = 111
// module chunks = 0